import {
    IntegrationConnection,
    ConnectionProvider,
} from "../types/integrationConnection";
import { FinancialAccountSourceType } from "../types/financialAccount";
import { FinancialConnection } from "../types/financialConnection";

interface IntegrationConnectionSettings {
    multipleAccountsPerConnection: boolean;
    label: string;
    financialAccountSourceType: FinancialAccountSourceType;
    // interval in hours, eg. 6 means "sync every 6 hours"
    recurringSyncInterval: number;
}

export const INTEGRATION_CONNECTIONS_SETTINGS: Record<
    ConnectionProvider,
    IntegrationConnectionSettings
> = {
    [ConnectionProvider.PAYPAL]: {
        multipleAccountsPerConnection: false,
        label: "PayPal",
        financialAccountSourceType: FinancialAccountSourceType.PAYPAL,
        recurringSyncInterval: 6,
    },
};

export function isIntegrationConnection(
    connection: FinancialConnection | IntegrationConnection,
): connection is IntegrationConnection {
    return "provider" in connection;
}

export function getIntegrationConnectionInstitutionName(
    connection: IntegrationConnection,
): string {
    return (
        connection.institutionName ??
        INTEGRATION_CONNECTIONS_SETTINGS[connection.provider].label
    );
}

export const STANDARD_DISCONNECTION_ERROR = "disconnected";
